export const es = {
  countries: {
    AR: "Argentina",
    BR: "Brasil",
    CL: "Chile",
    CO: "Colombia",
    ES: "España",
    US: "Estados Unidos",
    MX: "México",
    PY: "Paraguay",
    PR: "Puerto Rico",
    UY: "Uruguay",
  },
  countryInfo: {
    AR: {
      description: "es un país hermoso que está al sur, bien abajo, del mundo. Con personas muy amables, de varias culturas y países. A los argentinos les gusta mucho la comida, hablar mucho y reírse con sus amigos y sobre todo, fanáticos del fútbol.",
      facts: [
        "Es el actual campeón del mundo de fútbol",
        "Le gusta tomar mucho mate",
        "Tienen las empanadas más ricas del mundo",
      ],
    },
    BR: {
      description: "es un país lleno de colores y alegría! Tiene la selva más grande del mundo (el Amazonas), playas increíbles y animales como los monos y tucanes. ¡Allí celebran el Carnaval con disfraces brillantes y música que hace bailar a todos!",
      facts: [
        "¡Tienen monos que caben en tu mano (los titís)!",
        "Es el país del fútbol: ¡Pelé y Neymar son de aquí!",
        "Tienen una playa con arena rosa (en Fernando de Noronha)",
      ],
    },
    CL: {
      description: "es un país muy largo y estrecho, como una cinta entre el mar y las montañas. Tienen desiertos con estrellas brillantes, pingüinos felices en el sur y hasta una isla con gigantes de piedra llamados moáis.",
      facts: [
        "¡Puedes ver pingüinos en Punta Arenas!",
        "Tienen el desierto más seco (Atacama), ¡pero en invierno hay flores!",
        "La Isla de Pascua tiene estatuas misteriosas (moáis)",
      ],
    },
    CO: {
      description: "es como un arcoíris de naturaleza: tiene playas doradas, montañas verdes y un río que parece pintado de colores (Caño Cristales). ¡A los niños les encanta jugar con pompones de lana llamados 'chumbes'!",
      facts: [
        "Tienen un río de 5 colores (como un arcoíris líquido)",
        "¡Es el país con más especies de aves en el mundo!",
        "Aquí escribió Gabriel García Márquez sus cuentos mágicos",
      ],
    },
    ES: {
      description: "es un país con castillos de cuento, playas soleadas y fiestas llenas de música. ¡Aquí inventaron la paella, el flamenco y hasta la tradición de los Reyes Magos que traen regalos en enero!",
      facts: [
        "Tiene un castillo REAL donde vivió un dragón (el Alcázar de Segovia)",
        "¡Aquí nació Don Quijote, el caballero de los molinos de viento!",
        "Tienen una guerra divertida: ¡La Tomatina (tiran tomates como juego)!",
      ],
    },
    US: {
      description: "¡es el país de los superhéroes, los parques de diversiones y los osos grizzly! Tiene desiertos con cactus gigantes, montañas con nieve todo el año y ciudades con luces brillantes como Nueva York.",
      facts: [
        "Su símbolo es un águila calva (¡pero no es calva, solo tiene plumas blancas!)",
        "Tienen el parque de Disney más grande del mundo (en Florida)",
        "Inventaron la hamburguesa y el perrito caliente",
      ],
    },
    MX: {
      description: "es una piñata de colores: tiene pirámides antiguas, playas de arena blanca y comida deliciosa como los tacos. ¡Aquí celebran el Día de Muertos con calaveras de azúcar y flores de colores!",
      facts: [
        "Tienen un volcán donde viven los conejos más valientes (el Popocatépetl)",
        "¡Inventaron el chocolate y los chiles picantes!",
        "Tienen la fiesta más larga del mundo: ¡9 días de posadas en Navidad!",
      ],
    },
    PY: {
      description: "es un país lleno de selvas verdes, ríos gigantes y animales exóticos como los guacamayos. ¡Aquí hablan dos idiomas (español y guaraní) y les encanta tomar tereré (un mate frío para días calurosos)!",
      facts: [
        "Tiene la selva del Chaco, ¡hogar de jaguares y armadillos gigantes!",
        "Inventaron la guitarra paraguaya (¡suena como un arpa mágica!)",
        "Tienen las cataratas más grandes del mundo (¡las de Iguazú, compartidas con Argentina y Brasil!)",
      ],
    },
    PR: {
      description: "¡es una isla donde siempre brilla el sol! Tienen playas de arena blanca, bosques con luciérnagas que brillan de noche y una fortaleza donde los piratas escondían tesoros. ¡Aquí nació la salsa y el reggaetón!",
      facts: [
        "Tienen una playa que brilla en la oscuridad (¡gracias a plancton mágico en Vieques!)",
        "Aquí vive el coquí, una ranita que canta 'co-quí' de noche",
        "Tienen un castillo llamado 'El Morro' donde luchaban contra piratas",
      ],
    },
    UY: {
      description: "es un país pequeño pero lleno de sorpresas: tiene playas interminables, dinosaurios de verdad (¡sus fósiles!) y el carnival más largo del mundo. ¡A los uruguayos les encanta juntarse para hacer asados con amigos!",
      facts: [
        "Encontraron fósiles de un dinosaurio gigante (¡el Titanosaurio!)",
        "Tienen la playa más larga del mundo: Punta del Este (¡son 500 km de arena!)",
        "Su carnaval dura 40 días (¡con desfiles, tambores y disfraces!)",
      ],
    },
  },
  common: {
    loading: "Cargando...",
    back: "Volver",
    save: "Guardar",
    cancel: "Cancelar",
    yes: "Sí",
    no: "No",
    error: "Error",
    retry: "Reintentar",
    close: "Cerrar",
    next: "Siguiente",
    previous: "Anterior",
    understood: "¡Entendido!",
    confirm: "Confirmar",
    home: "Inicio",
    flag: "Bandera",
    pencil: "Lápiz",
    delete: "Borrar",
    speak: {
      listen: "Escuchar mensaje",
      stop: "Detener lectura",
    },
    voice: {
      record: "Grabar audio",
      stop: "Detener grabación",
      errors: {
        unsupported: "Tu navegador no soporta reconocimiento de voz",
        notAllowed: "Por favor, permite el acceso al micrófono",
        noSpeech: "No se detectó voz. Intenta de nuevo",
        audioCapture: "No se pudo acceder al micrófono",
        generic: "Error al grabar audio",
      },
    },
  },
  language: {
    label: "Idioma",
    spanish: "Castellano",
    english: "Inglés",
    select: "Seleccionar idioma",
    logout: "Cerrar sesión",
  },
  auth: {
    welcome: "¡Bienvenido a Howe!",
    selectProfile: "Seleccioná tu perfil para continuar",
    childLabel: "Niño",
    adultLabel: "Adulto",
    child: {
      hello: "¡Hola!",
      enterName: "Escribí tu nombre para ingresar",
      namePlaceholder: "Ej: Sofi, Mateo...",
      nameError: "Ingresá un nombre válido (mínimo 3 letras)",
      loginError: "Error al iniciar sesión. Por favor, intentá nuevamente.",
      loggingIn: "Iniciando sesión...",
      enter: "¡Ingresar!",
      noAccount: "¿No tenés una cuenta?",
      registerHere: "Registrate aquí",
    },
    resetPassword: {
      requestTitle: "Recuperar contraseña",
      requestDesc: "Ingresá tu email y te enviamos un link para cambiar tu contraseña.",
      emailLabel: "Email",
      emailPlaceholder: "tu@email.com",
      sendButton: "Enviar link",
      sending: "Enviando...",
      successTitle: "¡Email enviado!",
      successDesc: "Si el email existe en Howe, recibirás un link para cambiar tu contraseña.",
      backToLogin: "Volver al login",
      confirmTitle: "Nueva contraseña",
      confirmDesc: "Ingresá tu nueva contraseña.",
      passwordLabel: "Nueva contraseña",
      passwordPlaceholder: "Mínimo 8 caracteres",
      confirmButton: "Guardar contraseña",
      saving: "Guardando...",
      confirmSuccess: "¡Contraseña cambiada! Ya podés iniciar sesión.",
      invalidToken: "El link es inválido o expiró. Solicitá uno nuevo.",
      errorGeneric: "Ocurrió un error. Intentá de nuevo.",
    },
    invitation: {
      title: "Invitación a Grupo",
      description: "Te invitaron a formar parte de un grupo en Howe",
      group: "Grupo:",
      institution: "Institución:",
      responsible: "Adulto responsable:",
      yourName: "Tu nombre:",
      question: "¿Deseas aceptar esta invitación?",
      reject: "No, gracias",
      accept: "Sí, aceptar",
      accepting: "Aceptando...",
    },
    adult: {
      title: "Inicio de sesión",
      email: "Email",
      password: "Contraseña",
      login: "Iniciar sesión",
      register: "Registrarse",
      loggingIn: "Iniciando sesión...",
      loginError: "Credenciales inválidas",
      noAccount: "¿No tienes cuenta?",
      registerHere: "Regístrate",
      emailRequired: "Correo requerido",
      passwordRequired: "Contraseña requerida",
      forgotPassword: "¿Olvidaste tu contraseña?",
    },
  },
  menu: {
    myEmotions: "MIS EMOCIONES",
    myMusic: "MI MÚSICA",
    myArt: "MI ARTE",
    myHowe: "MI HOWE",
    myDiary: "MI DIARIO",
    myCommunity: "MI COMUNIDAD",
    myLibrary: "MI BIBLIOTECA",
    myRest: "MI DESCANSO",
    myRecipes: "MIS RECETAS",
    myGames: "MIS JUEGOS",
    myFamilyTree: "MI ÁRBOL FAMILIAR",
    myCommunication: "MI COMUNICACIÓN",
    welcomeMessage:
      "Podés recorrer tu casa, hacé click sobre el cuarto que querés visitar. Los cuartos en gris aún no están habilitados",
    backToMap: "Volver al mapa",
  },
  worldMap: {
    title: "Mapa del Mundo",
    selectCountry: "Seleccioná un país",
    myLocation: "Mi ubicación",
    addCountry: "Agregar país",
    removeCountry: "Quitar país",
    draw: "Dibujar",
    drawPrompt: "¿Querés dibujar algo sobre este país?",
    drawCanvas: "Lienzo de dibujo",
    saveDrawing: "Guardar dibujo",
    clearDrawing: "Limpiar",
    backToMap: "Volver al mapa",
    introTitle: "¡Bienvenido al mapa!",
    introMessage: "Explorá el mundo haciendo click en los países",
    skipIntro: "Saltar intro",
    searchCountries: "Buscar país...",
    countrySelectPrompt: "¿De dónde sos o dónde viviste?",
    introStep1: "acabas de ingresar a Howe. Mi nombre es **Wobi** y siempre te voy a acompañar en el recorrido de tu Hogar.",
    introStep2: "Para comenzar tienes el mundo disponible para dibujar y ubicar tu casa Howe. Comienza por agregar todos los países que desees incluir.",
    introStep3: "También puedes dibujar tu casa de la forma que más te guste.",
    introStep4: "Cuando termines de dibujar tu casa puedes empezar a recorrerla.",
    welcomeHowe: "Hola, bienvenido a Howe",
    locationNeeded: "Necesitamos tu ubicación para continuar",
    drawingQuestion: "¿Te gustaría dibujar tu casa HOWE?",
    nowInCountry: "Ahora estás en el país",
    goToMenu: "Ir al menú",
    drawHouse: "Dibujar casa",
    drawingSaved: "Te quedó re linda la casa que dibujaste",
    drawingSuccess: "Hermosa tu casa HOWE",
    drawingSuccessMsg: "Ya podés ingresar, decorarla y recorrerla como más te guste",
  },
  room: {
    title: "Mi Howe",
    save: "Guardar cuarto",
    saved: "¡Cuarto guardado!",
    changeWall: "Cambiar pared",
    addItem: "Agregar item",
    backToMenu: "Volver al menú",
    explore: "Recorre tu Howe.",
    changeWallColor: "¿De qué color te gustaría pintar las paredes?",
    decorate: "Acá tenés de todo. Empezá a decorar tu habitación.",
    designCharacter: "Diseña tu personaje.",
    backButton: "Volver al menú anterior",
    wobiTitle: "¡Hola",
    wobiSubtitle: "Este es tu cuarto Howe. Acá podés decorarlo y personalizarlo como quieras.",
    wobiRoomTitle: "En tu cuarto podés:",
    wobiHint: {
      home: "Volvé al menú principal",
      piggy: "Revisá tu alcancía de HoweCoins",
      brush: "Cambiá el color de las paredes",
      box: "Decorá tu cuarto con objetos",
      avatar: "Personalizá tu avatar",
    },
    insufficientCoins: "No tenés saldo suficiente para esta acción.",
  },
  diary: {
    roomGreeting: "¡Hola",
    roomMessage1: "📖 Hacé click en el diario sobre el escritorio para escribir tus pensamientos del día. ¡Solo vos podés leerlo!",
    roomMessage2: "🖼️ Tocá los cuadros de la pared para decorarlos con una ilustración o subir tu propia foto.",
    roomMessage3: "🎒 ¿Ves las mochilas del perchero? ¡Hacé click en cada una para descubrir qué llevan adentro!",
    coverTitle: "Mi Diario",
    framePicker: {
      title: "Elegí un cuadro para tu pared",
      apply: "¡Listo! 🎨",
      remove: "Quitar",
      cancel: "Cancelar",
      addFrame: "+ cuadro",
      uploadPhoto: "📷 Subir foto",
    },
    openDiary: "Abrir mi diario",
    diaryTip: "¡Este cuarto es tuyo para explorar y personalizar!",
    memoryShelfTitle: "✨ Mis Recuerdos",
    backpacksTitle: "🎒 Mochilas",
    backpacks: {
      back: "← Volver",
      green: {
        title: "Mochila del Colegio",
        items: [
          { e: "📚", l: "Libros",       desc: "Guardan todo lo que aprendés: historias, ciencias, matemáticas y mucho más. ¡Cada página es una aventura nueva!" },
          { e: "✏️", l: "Lápices",      desc: "Con ellos escribís, dibujás y creás. ¡Un lápiz puede convertir tus ideas en realidad!" },
          { e: "📐", l: "Regla",        desc: "Te ayuda a hacer líneas rectas y medir cosas. ¡Perfecta para geometría y dibujo técnico!" },
          { e: "🔬", l: "Ciencias",     desc: "Con la ciencia explorás el mundo: los animales, las plantas, el espacio y cómo funciona todo. ¡Sos un científico!" },
          { e: "🗺️", l: "Geografía",   desc: "Te enseña dónde están los países, ríos y montañas del mundo. ¡El mapa es tu pasaporte a todos los lugares!" },
          { e: "🧮", l: "Matemáticas",  desc: "Suma, resta, multiplica y divide. ¡Las matemáticas están en todas partes: en las recetas, en los juegos y en las estrellas!" },
        ],
      },
      pink: {
        title: "Mochila de Deporte",
        items: [
          { e: "⚽", l: "Pelota",    desc: "Para jugar en equipo, patear, pasarla y festejar los goles juntos. ¡El deporte une a todos!" },
          { e: "👟", l: "Zapatillas",desc: "Tus mejores amigas para correr, saltar y moverte. ¡Con buenas zapatillas, el camino es más fácil!" },
          { e: "🧢", l: "Gorra",     desc: "Te protege del sol cuando entrenás afuera. ¡También te da un look deportivo genial!" },
          { e: "💧", l: "Botella",   desc: "Hidratarse es súper importante cuando hacés ejercicio. ¡Tu cuerpo te lo agradece con más energía!" },
          { e: "🏃", l: "Running",   desc: "Correr fortalece tu corazón, tus piernas y tu mente. ¡Cada paso que das te hace más fuerte!" },
          { e: "🥊", l: "Guantes",   desc: "Para practicar boxeo o artes marciales. ¡Te enseñan disciplina, fuerza y a respetar a los demás!" },
        ],
      },
      yellow: {
        title: "Mochila de Arte",
        items: [
          { e: "🖌️", l: "Pinceles",  desc: "Con ellos pintás lo que imaginás. ¡Cada pincelada es una parte de vos expresándose en el papel!" },
          { e: "🎨", l: "Pinturas",   desc: "Los colores son tus palabras cuando el arte es tu idioma. ¡Mezclá y creá colores únicos!" },
          { e: "✂️", l: "Tijeras",   desc: "Para cortar, recortar y crear collages. ¡Con tijeras podés transformar papel en arte!" },
          { e: "📒", l: "Cuaderno",   desc: "Tu espacio secreto para bocetos, ideas y dibujos. ¡Cada página es una nueva posibilidad creativa!" },
          { e: "🖍️", l: "Crayones",  desc: "Suaves y coloridos, perfectos para rellenar y dar vida a tus dibujos. ¡No hay límites con los crayones!" },
          { e: "🌈", l: "Colores",    desc: "El arcoíris completo a tu disposición. ¡Los colores tienen el poder de transmitir emociones y contar historias!" },
        ],
      },
    },
    modal: {
      leftTitle: "📖 Mi Diario",
      rightTitle: "✨ Mis Pensamientos",
      leftPlaceholder: "Escribí aquí cómo te sentís hoy...\n\n¿Qué pasó hoy que fue especial?\n¿Cuál fue tu emoción favorita?",
      rightPlaceholder: "¿Qué te hace feliz?\n\nPodés dibujar con palabras...\no simplemente escribir lo que sentís 💛",
      prevPage: "← Anterior",
      nextPage: "Siguiente →",
      pageOf: "Página",
      of: "de",
      close: "Cerrar",
      today: "Hoy",
      saving: "Guardando...",
      loading: "📖 Cargando…",
      noEntries: "Sin entradas este mes",
      howAreYou: "¿Cómo estás hoy?",
      placeholder: "Contanos como estuvo tu día...",
      listening: "🎤 Escuchando…",
      changeEmotion: "Cambiar emoción",
      bgTitle: "Fondo",
      textTitle: "Escribir",
      micStart: "Dictar al diario",
      micStop: "Detener grabación",
      uploadImage: "Subir imagen",
      takePhoto: "Sacar foto",
      stickersTitle: "Stickers",
      saveTitle: "Guardar",
      stickerRemove: "Doble clic para quitar",
      stickerRemoveTap: "Click para quitar",
      micErrors: {
        unsupported: "Tu navegador no soporta reconocimiento de voz",
        notAllowed: "Permití el acceso al micrófono",
        noSpeech: "No se detectó voz. Intentá de nuevo",
        audioCapture: "No se pudo acceder al micrófono",
        generic: "Error al grabar",
      },
      days: ["L","M","M","J","V","S","D"],
      dayNames: ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],
      months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
      monthsShort: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
    },
  },
  avatar: {
    title: "PERSONALIZÁ TU AVATAR",
    gender: "Género",
    eyes: "Ojos",
    mouth: "Boca",
    hair: "Cabello",
    skin: "Tono de piel",
    shirts: "Camisas",
    pants: "Pantalones",
    shoes: "Calzado",
    saving: "Guardando...",
  },
  emotions: {
    labels: {
      alegre: "Siento alegría",
      feliz: "Siento felicidad",
      confiado: "Siento confianza",
      miedoso: "Siento miedo",
      enojado: "Siento enojo",
      sorprendido: "Siento sorpresa",
      disgustado: "Siento disgusto",
      triste: "Siento tristeza",
    },
    jarTitle: "¡Tocá el frasco!",
    intro: {
      greeting: "¡Hola",
      question: "¿Estás listo para explorar tus emociones conmigo?",
      message1: "¿Sabías que tus emociones son como superpoderes?",
      message2: "¡Sí, incluso la tristeza o el enojo!",
      message3:
        "Cada emoción te ayuda a conocerte mejor, a cuidarte y a expresarte.",
      start: "¡Empezar!",
      back: "Volver",
      roomTitle: "En este cuarto podrás:",
      option1: "Hablar conmigo sobre alguna emoción que estés sintiendo",
      option2: "Pintar tus emociones",
      option3: "Contarme si te molesta o duele alguna parte de tu cuerpo",
      bookHint: "¡Y también podés leer un cuento bonito sobre las emociones en la biblioteca!",
      jarHint: "Cada emoción que sentís se guarda en el frasco como un tesoro.",
      activityHint: "Y si querés sentirte mejor, ¡abrí la libreta y elegí una actividad!",
    },
    selector: {
      greeting: "Hola,\n¿querés contarme cómo te sentís hoy?\nElegí una emoción",
      mascotName: "Amby",
    },
    paint: {
      title: "🎨 Pintá tus emociones",
      subtitle: "Elegí un color y da vida a cada corazón con alegría.",
      progress: "corazones pintados",
      done: "¡Listo!",
      clear: "Limpiar",
    },
    names: {
      alegre: "Alegre",
      confiado: "Confiado",
      disgustado: "Disgustado",
      enojado: "Enojado",
      feliz: "Feliz",
      miedoso: "Miedoso",
      sorprendido: "Sorprendido",
      triste: "Triste",
    },
    detail: {
      back: "Volver",
      learnMore: "Saber más",
    },
    data: {
      alegre: {
        titulo: "¿Estás alegre?",
        subtitulo: "Siento alegría",
        descripcion: "La alegría es esa emoción que sentimos cuando algo nos hace felices, como un premio después de algo que salió bien. Cuando estamos alegres, nos sentimos llenos de energía y tenemos ganas de compartir con los demás. \nEsta emoción nos ayuda a acercarnos a otras personas, a ser más amables y a crear buenos recuerdos juntos. La alegría también hace que queramos repetir esas cosas que nos hicieron bien, ayudándonos a aprender y a construir lazos y vínculos.",
      },
      confiado: {
        titulo: "¿Estás confiado?",
        subtitulo: "Siento confianza",
        descripcion: "La confianza surge cuando nos sentimos seguros de nosotros mismos y de nuestras capacidades.\nNos permite enfrentar desafíos con determinación y creer en nuestras posibilidades.\nEs una emoción que nos ayuda a tomar decisiones y a avanzar con seguridad.\n\nCuando cultivamos la confianza, desarrollamos una actitud positiva hacia el futuro y fortalecemos nuestra autoestima.",
      },
      disgustado: {
        titulo: "¿Estás disgustado?",
        subtitulo: "Siento disgusto",
        descripcion: "El disgusto aparece cuando algo nos resulta desagradable o repulsivo.\nNos ayuda a evitar situaciones o elementos que podrían ser dañinos para nosotros.\nEs una emoción protectora que nos mantiene alejados de lo que consideramos negativo.\n\nCuando reconocemos nuestro disgusto, podemos tomar decisiones más saludables y establecer límites claros.",
      },
      enojado: {
        titulo: "¿Estás enojado?",
        subtitulo: "Siento enojo",
        descripcion: "El enojo surge cuando algo nos hace sentir atacados o cuando alguien no respeta nuestros límites. Es como una energía fuerte que se activa para ayudarnos a protegernos y defendernos. A veces, el enojo también nos da impulso para perseguir nuestras metas, siempre y cuando sepamos cómo manejarlo. Esta emoción es importante para crecer y adaptarnos a lo que nos rodea. Cuando entendemos por qué sentimos enojo, podemos usar esa energía de una forma que nos ayude a resolver problemas, en lugar de complicarlos.",
      },
      feliz: {
        titulo: "¿Estás feliz?",
        subtitulo: "Siento felicidad",
        descripcion: "La felicidad aparece cuando experimentamos bienestar y satisfacción con nuestra vida.\nNos ayuda a disfrutar del presente y a valorar lo que tenemos.\nEs una emoción que nos conecta con la gratitud y el optimismo.\n\nCuando cultivamos la felicidad, mejoramos nuestra calidad de vida y contagiamos positividad a quienes nos rodean.",
      },
      miedoso: {
        titulo: "¿Estás miedoso?",
        subtitulo: "Siento miedo",
        descripcion: "El miedo es una emoción que aparece cuando sentimos que algo puede hacernos daño, ya sea en nuestro cuerpo o en nuestra mente. Es como una alarma que nos avisa que algo no está bien y nos ayuda a escapar o a quedarnos quietos cuando es necesario.\n¡El miedo puede ser muy útil! Pero, si lo dejamos crecer demasiado, se puede transformar en una preocupación constante, que es como si siempre estuviéramos viendo peligro, aunque no esté realmente allí. Por eso, aprender a mirar de cerca nuestros miedos nos ayuda a entenderlos mejor y a superarlos, en lugar de que nos paralicen o nos limiten.",
      },
      sorprendido: {
        titulo: "¿Estás sorprendido?",
        subtitulo: "Siento sorpresa",
        descripcion: "La sorpresa surge cuando algo inesperado ocurre.\nNos ayuda a estar alerta y a adaptarnos a situaciones nuevas.\nEs una emoción que nos mantiene curiosos y abiertos al aprendizaje.\n\nCuando aceptamos la sorpresa, podemos disfrutar de nuevas experiencias y mantener una mente abierta.",
      },
      triste: {
        titulo: "¿Estás triste?",
        subtitulo: "Siento tristeza",
        descripcion: "La tristeza aparece cuando experimentamos pérdida o decepción.\nNos ayuda a procesar situaciones difíciles y a buscar apoyo.\nEs una emoción que nos permite sanar y crecer emocionalmente.\n\nCuando aceptamos nuestra tristeza, podemos aprender de nuestras experiencias y fortalecer nuestra resiliencia.",
      },
    },
    chat: {
      header: "Chat con Howe",
      initialQuestion: "¿Estás",
      predefinedPrompt: "Pueden elegir un motivo o escribirme…",
      listening: "Escuchando...",
      placeholder: "Escribe tu respuesta o presiona el micrófono para hablar...",
      predefined: {
        alegre: [
          "Estoy alegre porque jugué con mis amigos y me divertí.",
          "Tuve una visita de alguien que quiero mucho.",
          "Hice un paseo muy lindo en familia.",
        ],
        confiado: [
          "Me siento confiado porque estudié y practiqué lo suficiente.",
          "Sé que puedo hacerlo bien.",
          "Estoy seguro de mí mismo hoy.",
        ],
        disgustado: [
          "Me disgustó lo que pasó en el colegio.",
          "Me disgusté con alguien que quiero mucho.",
          "Porque algo no salió como esperaba.",
        ],
        enojado: [
          "Me enojé porque no me escucharon.",
          "Me enojé con alguien que quiero mucho.",
          "Me enojé por lo que sucedió en el colegio.",
        ],
        feliz: [
          "Estoy feliz porque compartí un paseo o actividad divertida.",
          "Me regalaron algo que me gusta.",
          "Pude ver a alguien que quiero.",
        ],
        miedoso: [
          "Porque me sentí solo.",
          "Escuché un ruido raro.",
          "Algo me asustó en la escuela.",
        ],
        sorprendido: [
          "Me sorprendió una visita que no esperaba.",
          "Recibí un regalo sin saberlo.",
          "Pasó algo que no imaginaba.",
        ],
        triste: [
          "Estoy triste porque extraño a alguien.",
          "No pude ver a alguien que quiero.",
          "Discutí con alguien a quien quiero mucho.",
        ],
      },
    },
  },
  books: {
    modal: {
      prev: "← Anterior",
      next: "Siguiente →",
      done: "¡Terminé! 🎉",
      alreadyRead: "✓ Ya leído",
      coinEarned: "¡Ganaste 10 monedas!",
      moral: "Aprendí que:",
      chapter: "Capítulo",
    },
    items: [
      {
        id: 0, emoji: "📖", title: "Mis emociones",
        chapters: [
          { title: "¿Qué son las emociones?", text: "Luna no entendía por qué a veces se sentía feliz, otras triste, y otras enojada, todo en el mismo día. Un día le preguntó a su abuela. La abuela sonrió y dijo: \"Las emociones son como los colores del arcoíris. Cada una tiene su nombre y su razón de ser.\"", moral: "Todas tus emociones son válidas y tienen un nombre." },
          { title: "El arcoíris interior", text: "Luna descubrió que tenía un arcoíris dentro del pecho. El rojo era el enojo, el azul la tristeza, el amarillo la alegría y el violeta la calma. \"¿Es normal tener tantos colores?\" preguntó. \"¡Claro! Cuantos más colores tenés, más rica es tu vida interior\", respondió su abuela.", moral: "Sentir muchas emociones distintas es completamente normal." },
          { title: "Abrazando tus colores", text: "Luna aprendió a no escapar de sus emociones. Cuando el azul llegaba, lo abrazaba un ratito. Cuando el rojo quería explotar, respiraba profundo. Y cuando el amarillo brillaba, lo compartía con todos.", moral: "Conocer tus emociones te hace más fuerte y más feliz." },
        ],
      },
      {
        id: 1, emoji: "😄", title: "La alegría",
        chapters: [
          { title: "La niña que hacía florecer todo", text: "La Alegría era una niña especial. Donde ponía los pies, brotaban flores. Cuando reía, el cielo se llenaba de pájaros. Los niños la seguían por los tejados del pueblo, saltando y cantando.", moral: "La alegría es uno de los mejores regalos que podemos compartir." },
          { title: "El pueblo gris", text: "Un día la Alegría se perdió y el pueblo se puso gris. Las flores se cerraron. Los pájaros se fueron. Un niño recordó algo: \"¡La Alegría no desapareció! Solo se escondió adentro nuestro.\"", moral: "La alegría siempre vuelve cuando hacemos cosas que amamos." },
          { title: "El baile que lo cambió todo", text: "El niño empezó a bailar solo en la plaza. Primero lo miraron raro. Luego uno se sumó, luego otro, y otro más. De repente, el pueblo entero bailaba y reía. Y la Alegría volvió corriendo.", moral: "Bailar, reír y jugar son los mejores remedios del corazón." },
        ],
      },
      {
        id: 2, emoji: "🤬", title: "El enojo",
        chapters: [
          { title: "El dragoncito rojo", text: "El Enojo era un dragoncito rojo con llamas en la boca. Solo quería una cosa: que lo escucharan. Pero todos le tenían miedo y se alejaban. Eso lo hacía enojar más.", moral: "El enojo nos avisa cuando algo nos parece injusto o nos duele." },
          { title: "El secreto del sabio", text: "Un sabio anciano no salió corriendo. Se sentó junto al dragoncito y le dijo: \"Cuando sientas que las llamas suben, respirá tres veces muy profundo.\" El dragoncito lo hizo y, de a poco, el fuego se convirtió en una pequeña luz cálida.", moral: "Respirar profundo ayuda a manejar el enojo sin lastimar a nadie." },
          { title: "Las palabras mágicas", text: "El dragoncito aprendió a decir: \"Estoy enojado porque...\" y a explicar lo que le pasaba. La gente empezó a entenderlo. Ya no necesitaba las llamas para ser escuchado.", moral: "Poner en palabras el enojo es mucho más poderoso que explotar." },
        ],
      },
      {
        id: 3, emoji: "😰", title: "El miedo",
        chapters: [
          { title: "La sombra protectora", text: "El Miedo era una sombra pequeñita que vivía debajo de las camas y detrás de las puertas. Pero no era malvado. Solo quería proteger a los niños de los peligros.", moral: "El miedo existe para cuidarnos. No es nuestro enemigo." },
          { title: "La conversación de Sofía", text: "Sofía decidió hablarle al Miedo directamente. \"¿Por qué me hacés asustar?\" La sombra respondió suavecito: \"Porque lo que viene es importante para vos. Solo quiero que estés lista.\"", moral: "Cuando conocemos nuestro miedo, ya no tiene tanto poder." },
          { title: "El pasito valiente", text: "Sofía entendió que ser valiente no es no tener miedo. Es sentir el miedo en la panza y animarse igual, de a poquito, un pasito a la vez.", moral: "El coraje no es la ausencia de miedo, sino dar un pasito aunque tiemble." },
        ],
      },
      {
        id: 4, emoji: "😢", title: "La tristeza",
        chapters: [
          { title: "La nube azul", text: "La Tristeza era una nube azul suave que a veces venía a visitar. No era mala, solo quería decir algo importante: que algo que nos importaba mucho había cambiado.", moral: "La tristeza es una señal de que algo nos importó mucho." },
          { title: "El llanto de Mateo", text: "Mateo aprendió a dejar que la Tristeza se quedara un ratito. Lloraba un poco, y después sentía que el corazón le pesaba menos. \"¿Por qué me siento mejor?\", preguntó. \"Porque las lágrimas limpian el corazón por adentro\", le respondió la nube.", moral: "Llorar está bien. Las lágrimas limpian el corazón por adentro." },
          { title: "Después de la lluvia", text: "La nube azul le enseñó a Mateo su secreto más grande: después de cada lluvia, el cielo queda más limpio y el sol brilla más fuerte. Lo mismo pasa con el corazón.", moral: "Después de cada tristeza hay más espacio en el corazón para la felicidad." },
        ],
      },
      {
        id: 5, emoji: "😌", title: "La calma",
        chapters: [
          { title: "El lago de la montaña", text: "En lo alto de una montaña muy alta había un lago cristalino. Sus aguas eran tan quietas que reflejaban perfectamente el cielo, las nubes y las estrellas. Ese lago era la Calma.", moral: "La calma es un lugar que siempre podemos encontrar adentro nuestro." },
          { title: "El viaje secreto", text: "Una niña descubrió que podía visitar ese lago sin moverse de su cuarto. Solo tenía que cerrar los ojos, respirar despacio y contar hasta diez. De repente, ahí estaba el lago.", moral: "Respirar despacio y cerrar los ojos son los pasos para encontrar la calma." },
          { title: "El secreto compartido", text: "La niña le enseñó el secreto a sus amigos uno a uno. \"¿De verdad funciona?\", preguntaban. \"Sí\", decía ella, \"adentro de cada uno hay un lugar tranquilo. Solo hay que saber llegar.\"", moral: "La calma no viene de afuera. Vive adentro tuyo, siempre lista." },
        ],
      },
      {
        id: 6, emoji: "🥰", title: "El amor",
        chapters: [
          { title: "El hilo invisible", text: "El Amor era un hilo invisible que unía a las personas. No se podía ver, pero se sentía: en un abrazo apretado, en alguien que te escucha de verdad, en un plato de tu comida favorita hecho con cariño.", moral: "El amor se demuestra en los gestos pequeños de todos los días." },
          { title: "Sin palabras", text: "Un niño estaba muy triste. Su perro se acercó, se acostó a su lado y apoyó la cabeza en sus piernas. No dijo nada. Solo estuvo ahí. Y eso fue suficiente.", moral: "El amor más puro a veces viene sin palabras, solo con presencia." },
          { title: "El amor más importante", text: "La niña aprendió algo sorprendente: cuanto más amor daba, más amor tenía. Y la forma más importante de todos era el amor a uno mismo: cuidarse, respetarse y ser amable con uno mismo.", moral: "Quererte a vos mismo es el primer paso para querer bien a los demás." },
        ],
      },
      {
        id: 7, emoji: "🥹", title: "El orgullo",
        chapters: [
          { title: "El sol chiquito", text: "El Orgullo era un sol chiquito que brillaba dentro del pecho. Aparecía cuando hacías algo con esfuerzo, cuando te caías y te levantabas, cuando lograba algo que creías imposible.", moral: "El orgullo sano nace de tu propio esfuerzo, no de compararte con otros." },
          { title: "La bicicleta de Valentina", text: "Valentina tardó tres semanas en aprender a andar en bicicleta. Se cayó muchas veces. Pero un día pedaleó sola hasta el final de la calle. El sol chiquito de su pecho brilló como nunca.", moral: "Cada logro, por pequeño que sea, merece que te sientas orgulloso." },
          { title: "Superarse uno mismo", text: "Valentina entendió que el orgullo más lindo no es ganarle a los demás. Es mirarse al espejo y ver todo lo que creció, aprendió y mejoró.", moral: "El verdadero orgullo es mirar atrás y ver todo lo que creciste." },
        ],
      },
      {
        id: 8, emoji: "😲", title: "La sorpresa",
        chapters: [
          { title: "La emoción traviesa", text: "La Sorpresa era la emoción más traviesa de todas. Aparecía cuando menos se esperaba: en una esquina, detrás de una puerta, en el medio de un día normal.", moral: "Las sorpresas nos recuerdan que la vida está llena de cosas nuevas." },
          { title: "La fiesta de Tomás", text: "Tomás no gustaba de las sorpresas. Le daban miedo lo desconocido. Pero un día su familia le organizó una fiesta secreta. Cuando entró y todos gritaron \"¡Sorpresa!\", su corazón dio un salto de alegría.", moral: "A veces lo inesperado trae los momentos más felices de la vida." },
          { title: "Los ojos curiosos", text: "Desde entonces, Tomás empezó cada mañana preguntándose: \"¿Qué cosa increíble me esperará hoy?\" Y el mundo se llenó de sorpresas maravillosas.", moral: "Mirar el mundo con ojos curiosos convierte los días ordinarios en aventuras." },
        ],
      },
      {
        id: 9, emoji: "😊", title: "La confianza",
        chapters: [
          { title: "La semilla dorada", text: "La Confianza era una semilla dorada que vivía en el corazón de cada persona. Crecía con cada palabra amable que uno se decía a sí mismo, con cada pequeño logro, con cada vez que uno intentaba algo nuevo.", moral: "La confianza en uno mismo crece con cada pequeño paso que damos." },
          { title: "El dibujo de Bautista", text: "Bautista creyó que no sabía dibujar. Su maestra lo miró y dijo: \"No sos malo dibujando. Sos principiante. Todos los grandes artistas empezaron exactamente igual que vos.\"", moral: "Creer que podés aprender es el primer paso para lograrlo." },
          { title: "Intentarlo de nuevo", text: "Bautista entendió que la confianza no es salir perfecto la primera vez. Es saber que podés intentarlo de nuevo, aprender del error y mejorar cada vez más.", moral: "Confiar en vos mismo significa saber que podés levantarte aunque te caigas." },
        ],
      },
      {
        id: 10, emoji: "☀️", title: "La felicidad",
        chapters: [
          { title: "Los momentos simples", text: "La Felicidad no vivía en los castillos ni en los juguetes caros. Vivía en una pizza caliente, en la lluvia vista desde abajo de las cobijas, en un abrazo sin motivo en el medio del día.", moral: "La felicidad vive en los momentos pequeños, no solo en los grandes." },
          { title: "La búsqueda de Mía", text: "Mía buscaba la felicidad en juguetes nuevos y en ganar siempre. Un día, abrazando a su perro en el patio, la encontró. La felicidad estaba ahí, quietita, esperando que ella parara.", moral: "La felicidad no se compra ni se gana. Se siente cuando estás presente." },
          { title: "El tesoro de los momentos", text: "Mía aprendió a coleccionar momentos felices como si fueran tesoros. Los guardaba en el corazón para los días grises. Y cuando llegaban esos días, los sacaba uno por uno.", moral: "Guardar momentos felices en tu corazón te ayuda en los días difíciles." },
        ],
      },
      {
        id: 11, emoji: "🤢", title: "El disgusto",
        chapters: [
          { title: "El guardián de los límites", text: "El Disgusto era un guardián serio pero importante. Avisaba cuando algo no estaba bien, cuando algo olía feo, sonaba mal o se sentía injusto. Era el que decía: \"Esto no está bien para vos.\"", moral: "El disgusto nos protege de cosas que nos hacen daño o no nos gustan." },
          { title: "Las palabras de Camila", text: "Un día alguien le dijo algo feo a Camila. El Disgusto le apretó el pecho. Camila respiró y dijo en voz firme: \"Eso que dijiste no me gustó. Por favor, no lo hagas más.\" Y se sintió muy bien.", moral: "El disgusto nos da la señal para poner límites con palabras claras y amables." },
          { title: "Está bien no gustar todo", text: "Camila aprendió que está perfectamente bien no gustarle todo. No tiene que comer lo que no le gusta, ni jugar a lo que no quiere, ni aguantar lo que le hace mal. Decir \"esto no me gusta\" es un acto de amor propio.", moral: "Respetar lo que no te gusta es una forma de cuidarte y quererte a vos mismo." },
        ],
      },
    ],
  },
  activities: {
    panelTitle: "¡Actividades para sentirte mejor!",
    coins: "monedas",
    items: [
      {
        id: "respiracion",
        title: "Respiración profunda",
        description: "Respirá hondo 5 veces. Inhalá por la nariz, exhalá por la boca.",
        coins: 10,
      },
      {
        id: "bailar",
        title: "Bailar una canción",
        description: "Ponete tu canción favorita y bailá sin parar por 2 minutos.",
        coins: 10,
      },
      {
        id: "dibujar",
        title: "Dibujar cómo me siento",
        description: "Agarrá un papel y dibujá tu emoción. ¡Lo que vale es expresarte!",
        coins: 10,
      },
      {
        id: "espejo",
        title: "Decirme algo lindo",
        description: "Mirate al espejo y decí 3 cosas lindas de vos. ¡Sos increíble!",
        coins: 10,
      },
      {
        id: "saltos",
        title: "Hacer 10 saltos",
        description: "Saltá con todo tu cuerpo 10 veces. ¡El ejercicio te pone de buen humor!",
        coins: 10,
      },
      {
        id: "abrazo",
        title: "Pedir un abrazo",
        description: "Buscá a alguien que querés y pedile un abrazo fuerte.",
        coins: 10,
      },
    ],
  },
  chakra: {
    title: "¿Qué siento en mi cuerpo?",
    subtitle: "Tocá la parte del cuerpo donde sentís algo",
    back: "Inicio",
    confirm: "Confirmar",
    yes: "Sí",
    no: "No",
    chakras: {
      corona: {
        name: "Chakra Corona",
        subtitle: "Para cuando te duele la cabeza",
        description:
          "Este chakra está en la parte de arriba de tu cabeza. Cuando te sentís confundido, preocupado o te duele la cabeza, este chakra necesita atención.",
        question:
          "¿Sentís dolor de cabeza o te cuesta pensar con claridad?",
      },
      "tercer-ojo": {
        name: "Chakra Tercer Ojo",
        subtitle: "Para cuando te duele la frente",
        description:
          "Este chakra está en tu frente, entre tus ojos. Te ayuda a concentrarte y a entender las cosas. Cuando estás muy cansado o te duele la frente, este chakra necesita ayuda.",
        question: "¿Te duele la frente o te cuesta concentrarte?",
      },
      garganta: {
        name: "Chakra Garganta",
        subtitle: "Para cuando te duele la garganta",
        description:
          "Este chakra está en tu garganta. Te ayuda a expresar lo que sentís y pensás. Cuando te cuesta hablar, tenés dolor de garganta o sentís un nudo en la garganta, este chakra necesita atención.",
        question:
          "¿Sentís molestias en la garganta o te cuesta decir lo que pensás?",
      },
      corazon: {
        name: "Chakra Corazón",
        subtitle: "Para cuando te duele el pecho",
        description:
          "Este chakra está en el centro de tu pecho. Es el lugar del amor y las emociones. Cuando te sentís triste, solo o te duele el pecho, este chakra necesita cuidado.",
        question: "¿Sentís tu pecho apretado o te duele el corazón?",
      },
      plexo: {
        name: "Chakra Plexo Solar",
        subtitle: "Para cuando te duele el estómago",
        description:
          "Este chakra está en tu estómago. Es donde sentís las 'mariposas' cuando estás nervioso. Cuando tenés miedo, ansiedad o te duele la panza, este chakra necesita equilibrio.",
        question:
          "¿Sentís mariposas en el estómago, nervios o te duele la panza?",
      },
      sacro: {
        name: "Chakra Sacro",
        subtitle: "Para cuando te duele el bajo vientre",
        description:
          "Este chakra está debajo de tu ombligo. Te ayuda a sentirte creativo y alegre. Cuando te sentís sin energía o te duele el bajo vientre, este chakra necesita atención.",
        question:
          "¿Sentís molestias en tu bajo vientre o te sentís sin ganas de nada?",
      },
      raiz: {
        name: "Chakra Raíz",
        subtitle: "Para cuando te duele la parte de abajo",
        description:
          "Este chakra está en la parte más baja de tu cuerpo. Te hace sentir seguro y protegido. Cuando te sentís inseguro, con miedo o te duele la parte de abajo, este chakra necesita fortalecerse.",
        question:
          "¿Te sentís inseguro o tenés molestias en la parte baja de tu cuerpo?",
      },
    },
    exploreTitle: "¡Explora tu",
    howToExplore: "¿Cómo querés explorar?",
    bodyQuestion: "¿En esta parte sentís molestia o dolor?",
    introText: "Nuestro cuerpo también responde a cómo nos sentimos: ¡contame cómo te sentís hoy! Señalá la parte de tu cuerpo que te molesta o duele.",
    actions: {
      Dibujar: "Dibujar",
      Hablar: "Hablar",
      Respirar: "Respirar",
      Imaginar: "Imaginar",
    },
    chakrasData: {
      raiz: {
        title: "Chacra Raíz",
        texto: "Aquí te conectas con tu seguridad y fuerza al estar firme y tranquilo.",
      },
      sacro: {
        title: "Chacra Sacro",
        texto: "Este chakra te ayuda a sentir placer y creatividad en tus movimientos.",
      },
      ombligo: {
        title: "Chacra Ombligo",
        texto: "Siente cómo tu energía fluye y te ayuda a procesar emociones internas.",
      },
      corazon: {
        title: "Chacra Corazón",
        texto: "Te enseña a dar y recibir amor con cariño y apertura.",
      },
      garganta: {
        title: "Chacra Garganta",
        texto: "Expresa tu voz y comunícate con confianza y claridad.",
      },
      "tercer-ojo": {
        title: "Chacra Tercer Ojo",
        texto: "Despierta tu imaginación y tu intuición para ver más allá.",
      },
      corona: {
        title: "Chacra Corona",
        texto: "Conecta con tu sabiduría y tu espíritu para sentir paz interior.",
      },
    },
    exercises: {
      corona: {
        title: "Mi Estrella Brillante",
        exerciseTitle: "✨ Lluvia de Estrellitas",
        steps: [
          "Levanta tus brazos bien alto hacia el cielo, como si quisieras tocar las nubes. Ahora cierra los ojos e imagina que desde arriba empiezan a caer estrellitas doradas y brillantes, muy suavecitas.",
          "Las estrellitas caen sobre tu cabeza y bajan lentamente por todo tu cuerpo, tocando tus hombros, tu pecho, tu pancita, tus piernas... hasta llegar a tus pies. Mientras imaginas esto, baja tus brazos muy despacio, como si las estrellitas fueran cayendo con ellos.",
          "Siente cómo las estrellitas mágicas se llevan cualquier molestia de tu cabeza. ¡Son estrellitas sanadoras! 🌟",
        ],
        duration: "⏱️ Hazlo 3 veces despacito",
      },
      "tercer-ojo": {
        title: "Mi Imaginación",
        exerciseTitle: "☁️ La Nube Mágica",
        steps: [
          "Cierra tus ojos suavemente. Con un dedito, toca muy suavecito el centro de tu frente, justo entre tus cejas. Ahora imagina que aparece una nube del color que más te gusta.",
          "¿Qué color tiene tu nube? ¿Rosa? ¿Azul? ¿Dorada? Mira cómo tu nube flota despacito en el cielo de tu imaginación. La nube se mueve con el viento, va para un lado, después para el otro, sube y baja...",
          "Sigue a tu nube con tu mente, como si estuvieras viendo una película. Tu nube mágica se lleva cualquier molestia de tu frente. Respira tranquilo mientras la ves flotar. 🌈",
        ],
        duration: "⏱️ 1 minuto mirando tu nube",
      },
      garganta: {
        title: "Mi Voz Importante",
        exerciseTitle: "🦁 El León que Ruge",
        steps: [
          "¡Vamos a ser un león valiente! Primero, siéntate cómodo y pon tus manos sobre tus rodillas.",
          "Ahora abre tu boca bien grande, grande, GRANDE (como un león cuando bosteza). Saca tu lengua lo más que puedas y di \"Aaaaahhh\" bien fuerte, como el rugido de un león. ¡AAAAAHHH! 🦁",
          "Hazlo 3 veces. Después de rugir como león, ahora vas a susurrar algo muy bonito que quieras decir. Puede ser \"Me quiero mucho\" o \"Soy valiente\" o lo que tú quieras. Dilo bajito, como un secreto especial.",
          "Esto ayuda a que tu garganta se relaje y se sienta mejor. 💙",
        ],
        duration: "⏱️ 3 rugidos + 1 susurro bonito",
      },
      corazon: {
        title: "Mi Corazón Amoroso",
        exerciseTitle: "🦋 Abrazo de Mariposa",
        steps: [
          "Cruza tus brazos sobre tu pecho, como si te estuvieras dando un abrazo. Pon tu mano derecha sobre tu hombro izquierdo y tu mano izquierda sobre tu hombro derecho.",
          "Ahora vas a dar palmaditas suaves, primero con una mano, después con la otra, como si fueran las alas de una mariposa que vuela: tap-tap, tap-tap, tap-tap. Despacito y con cariño. 🦋",
          "Mientras haces esto, piensa en alguien que quieres mucho: tu mamá, tu papá, tu abuelita, tu mascota, tu mejor amigo... Siente todo el amor que hay en tu corazón. Ese amor es como una luz verde y cálida que brilla en tu pecho.",
          "Las palmaditas de mariposa calman tu corazón y te hacen sentir acompañado. 💚",
        ],
        duration: "⏱️ 1 minuto de palmaditas suaves",
      },
      plexo: {
        title: "Mi Fuerza Interior",
        exerciseTitle: "🦸 El Superhéroe",
        steps: [
          "¡Es hora de convertirte en un superhéroe! Párate bien firme con tus pies separados (del ancho de tus hombros). Pon tus manos en tu cintura, como hacen los superhéroes.",
          "Saca tu pecho hacia adelante, levanta tu cabeza bien alto y respira profundo por la nariz. Siente cómo el aire llena tu pancita de fuerza y poder. ⚡",
          "Ahora di estas palabras en voz alta, con mucha seguridad: \"¡Soy fuerte!\" \"¡Soy valiente!\" \"¡Puedo hacerlo!\"",
          "Di cada frase 3 veces. Siente cómo tu estómago se llena de energía dorada y brillante. Eres más fuerte de lo que crees. 💪✨",
        ],
        duration: "⏱️ Di las 3 frases, 3 veces cada una",
      },
      sacro: {
        title: "Mi Pancita Feliz",
        exerciseTitle: "🌊 Respiración de la Ola",
        steps: [
          "Acuéstate o siéntate cómodo. Pon tus dos manos sobre tu pancita, justo debajo de tu ombligo. Cierra los ojos si quieres.",
          "Imagina que tu pancita es el mar, y cuando respiras, haces olas. Respira profundo por la nariz y siente cómo tu pancita sube como una ola grande y suave. Después, saca el aire por la boca y siente cómo la ola baja despacito. 🌊",
          "Imagina que el mar de tu pancita tiene un color naranja calientito, como el sol cuando se esconde. Ese color cálido hace que tu pancita se sienta cómoda y relajada.",
          "Sube la ola... baja la ola... sube... baja... Despacito y tranquilo, como las olas del mar en un día bonito.",
        ],
        duration: "⏱️ Haz 8 olas (8 respiraciones)",
      },
      raiz: {
        title: "Mis Pies en la Tierra",
        exerciseTitle: "🌳 Caminar Descalzo Imaginario",
        steps: [
          "Párate firme con tus pies bien plantados en el suelo. Si puedes, quítate los zapatos para sentir mejor el piso (pero no es obligatorio).",
          "Cierra los ojos y imagina que tus pies son las raíces de un árbol grande y fuerte. Esas raíces empiezan a crecer y a hundirse despacito en la tierra, bajando, bajando, bajando... hasta llegar al mismísimo centro de la Tierra. 🌍",
          "Siente cómo tus raíces te sostienen firme y seguro. Nadie puede moverte porque estás bien plantado, como un árbol antiguo. Ahora respira profundo 5 veces, sintiendo tus pies en el suelo.",
          "Con cada respiración, imagina que tu árbol crece más fuerte. Tus raíces te dan fuerza y te hacen sentir seguro y tranquilo. 🌳",
        ],
        duration: "⏱️ 5 respiraciones profundas",
      },
    },
  },
  adult: {
    nav: {
      home: "Inicio",
      profile: "Mi Perfil",
      groups: "Mis Grupos",
      gestionGrupos: "Gestión de Grupos",
      gestionGruposNoAdmin: "Función habilitada solo para usuarios administradores de instituciones.",
      statistics: "Estadísticas",
      visitHowes: "Visitar Howes",
    },
    gestion: {
      title: "Gestión de Usuarios y Grupos",
      subtitle: "Visualizá los grupos y usuarios de tus instituciones",
      institutionLabel: "Institución",
      institutionPlaceholder: "Seleccioná una institución",
      loading: "Cargando grupos...",
      noGroups: "No hay grupos registrados para esta institución todavía.",
      colGroup: "Grupo",
      colCreador: "Creador",
      colTotal: "Total niños",
      colLinked: "Con cuenta vinculada",
      colUnlinked: "Sin cuenta vinculada",
      modalAdultsSubtitle: "Adultos responsables del grupo",
      modalNoAdults: "Sin adultos asignados",
      modalChildrenAll: "Todos los niños del grupo",
      modalChildrenLinked: "Niños con cuenta vinculada",
      modalChildrenUnlinked: "Niños sin cuenta vinculada",
      modalNoChildren: "Sin niños en esta categoría",
      tagLinked: "Vinculado",
      usersTitle: "Usuarios",
      usersSubtitle: "Adultos con al menos un grupo en esta institución",
      colUser: "Usuario",
      colGroups: "Grupos",
      colAdmin: "Admin",
      colActions: "Acciones",
      adminYes: "Sí",
      adminNo: "No",
      btnSetAdmin: "Dar admin",
      btnRemoveAdmin: "Quitar admin",
      btnUnlink: "Desvincular usuario del grupo",
      confirmUnlinkTitle: "Desvincular usuario de la institución",
      confirmUnlinkSole: "El usuario es el único responsable de los siguientes grupos, que serán ELIMINADOS:",
      confirmUnlinkShared: "El usuario también será removido de estos grupos (que continuarán con otros responsables):",
      confirmUnlinkQuestion: "¿Está seguro que desea continuar?",
      confirmUnlinkBtn: "Sí, desvincular",
      cancelBtn: "Cancelar",
      noUsers: "No hay usuarios registrados para esta institución todavía.",
      colRecibeAlertas: "Recibe Alertas de Howe",
      toastAlertaOn: "Alertas activadas correctamente",
      toastAlertaOff: "Alertas desactivadas correctamente",
      toastAlertaError: "Error al actualizar recibe alertas",
      grupoConfianzaTitle: "Grupo de Confianza",
      grupoConfianzaDesc: "Estos mails recibirán notificaciones cuando Howe detecte una situación de riesgo.",
      grupoConfianzaVerGrupo: "Ver Grupo de Confianza",
      grupoConfianzaOcultar: "Ocultar",
      grupoConfianzaUsuarios: "Usuarios con alertas activas",
      grupoConfianzaExtra: "Mails adicionales",
      grupoConfianzaNoUsuarios: "Ningún usuario tiene alertas activadas para esta institución.",
      grupoConfianzaNoExtra: "Sin mails adicionales configurados.",
      grupoConfianzaAddPlaceholder: "Ingresá un email",
      grupoConfianzaBtnAdd: "Agregar",
      grupoConfianzaBtnSave: "Guardar cambios",
      grupoConfianzaSaved: "Grupo de confianza actualizado correctamente",
      grupoConfianzaError: "Error al actualizar el grupo de confianza",
      grupoConfianzaInvalidEmail: "Ingresá un email válido",
    },
    home: {
      title: "Bienvenido a Howe",
      subtitle: "Panel de control para adultos",
      groupsCard: "Mis Grupos",
      groupsCardSub: "grupos creados",
      statsCard: "Estadísticas",
      statsCardSub: "Visualiza las emociones de tus grupos",
      howesCard: "Visitar Howes",
      howesCardSub: "Explora los espacios de los niños",
    },
    profile: {
      title: "Mi Perfil",
      subtitle: "Información personal y estado de aprobación",
      approved: "✓ Perfil Aprobado",
      pending: "⏳ Perfil Pendiente de Aprobación",
      pendingWarning: "Tu perfil está pendiente de aprobación por el equipo de Howe. Una vez aprobado, podrás copiar y compartir los links de invitación a los grupos.",
      email: "Email",
      name: "Nombre",
      lastName: "Apellido",
      country: "País",
      stateProvince: "Estado/Provincia/Ciudad",
      selectCountry: "Selecciona tu país...",
      selectState: "Selecciona tu provincia/estado...",
      selectCountryFirst: "Primero selecciona un país...",
      noStates: "No hay estados disponibles para este país",
      save: "Guardar Cambios",
    },
    groups: {
      title: "Mis Grupos",
      subtitle: "Administra los grupos de niños a tu cargo",
      pendingWarning: "Tu perfil está pendiente de aprobación por el equipo de Howe. Una vez aprobado, podrás copiar y compartir los links de invitación a los grupos.",
      noGroups: "No tienes grupos creados",
      noGroupsDesc: "Crea tu primer grupo para comenzar a gestionar la información de los niños",
      newGroup: "+ Nuevo Grupo",
      editGroup: "Editar Grupo",
      deleteGroup: "Eliminar Grupo",
      shareGroup: "Compartir Grupo",
      shareModalTitle: "Compartir grupo",
      shareModalDesc: "Seleccioná usuarios de la institución o ingresá emails separados por coma.",
      shareModalMembersLabel: "Usuarios de la institución",
      shareModalEmailLabel: "Ingresar emails manualmente (separados por coma)",
      shareModalEmailPlaceholder: "usuario1@email.com, usuario2@email.com",
      shareModalNoMembers: "No hay otros usuarios adultos registrados en esta institución.",
      shareSelectAll: "Seleccionar todos",
      shareDeselectAll: "Deseleccionar todos",
      shareCancel: "Cancelar",
      shareConfirm: "Compartir",
      shareSharing: "Compartiendo...",
      shareInvalidUsers: "Los siguientes usuarios no son válidos:",
      shareSuccess: "Grupo compartido con {count} usuario(s) correctamente",
      shareNoTarget: "Seleccioná al menos un usuario o ingresá un email válido",
      viewChildren: "👥 Ver Niños del Grupo",
      addChild: "+ Agregar Niño",
      deleteSelected: "🗑️ Eliminar Seleccionados",
      excelTemplateButton: "⬇️ Descargar planilla modelo",
      excelImportButton: "📄 Importar desde Excel",
      excelImporting: "Importando...",
      refreshChildren: "Actualizar",
      excelImportEmpty: "No se encontraron niños en la planilla para el grupo \"{grupo}\". Revisá que la columna \"Nombre del Grupo\" coincida exactamente.",
      excelImportSuccess: "Planilla procesada con éxito: {total} niño(s) agregado(s) al grupo, {success} usuario(s) creado(s)",
      excelImportPending: "{pending} niño(s) quedaron sin usuario porque ya existía ese nombre de usuario — invitalos manualmente.",
      excelImportError: "Error al procesar la planilla. Intentá nuevamente.",
      childCount: "niño(s) en el grupo",
      yourRole: "🤝 Tu rol:",
      noChildren: "No hay niños agregados",
      colName: "Nombre",
      colLastName: "Apellido",
      colGender: "Género",
      colEmail: "Email",
      colStatus: "Estado",
      colActions: "Acciones",
      linked: "✓ Vinculado",
      pendingStatus: "⏳ Pendiente",
      linkedUser: "👤 Usuario:",
      titleTooltipLinked: "Ya vinculado - Usuario ID:",
      titleTooltipPending: "Perfil pendiente de aprobación",
      titleTooltipCopyLink: "Copiar link de invitación",
      titleTooltipInstInactive: "La Institución no está Activa para invitar niños. Consultá con su Admin.",
      titleTooltipEdit: "Desmarque otras filas para editar",
      titleTooltipDelete: "Eliminar",
      instInactiveWarning: "Este grupo está relacionado a una institución Inactiva. No se puede acceder a la información del grupo.",
    },
    stats: {
      title: "Estadísticas de Emociones",
      subtitle: "Evolución de las emociones en tus grupos",
      institution: "Institución (opcional)",
      allInstitutions: "No especifica",
      group: "Grupo",
      from: "Desde",
      to: "Hasta",
      selectGroup: "Selecciona un grupo...",
      selectGroupWarning: "⚠️ Por favor selecciona un grupo para ver las estadísticas de emociones",
      linkedChildren: "Niños vinculados:",
      registeredEmotions: "Emociones registradas:",
      workedChakras: "Chakras trabajados:",
      noData: "No se pudieron cargar las estadísticas",
      charts: {
        emotionTitle: "Selección de Emociones",
        emotionEmpty: "No hay emociones registradas en el periodo seleccionado",
        chakraTitle: "Trabajo de Chakras",
        chakraEmpty: "No hay chakras registrados en el periodo seleccionado",
        totalRecords: "Total de registros:",
        records: "registros",
        analysisTitle: "Análisis del Grupo",
        emotionsLabel: "Emociones",
        chakrasLabel: "Chakras",
        analysisDisclaimer: "* Este análisis es generado automáticamente basado en los datos agregados del grupo. No incluye información individual de los niños para preservar su privacidad.",
      },
      emotionNames: {
        alegre: "Alegre",
        confiado: "Confiado",
        disgustado: "Disgustado",
        enojado: "Enojado",
        feliz: "Feliz",
        miedoso: "Miedoso",
        sorprendido: "Sorprendido",
        triste: "Triste",
      },
      chakraNames: {
        raiz: "Raíz",
        sacro: "Sacro",
        plexo: "Plexo Solar",
        corazon: "Corazón",
        garganta: "Garganta",
        tercerOjo: "Tercer Ojo",
        corona: "Corona",
        desconocido: "Desconocido",
      },
    },
    howes: {
      title: "Visitar Howes",
      subtitle: "Selecciona el Howe de un niño para visitarlo",
      comingSoon: "Próximamente",
      comingSoonDesc: "Esta funcionalidad estará disponible pronto",
    },
    modal: {
      editGroup: "Editar Grupo",
      newGroup: "Nuevo Grupo",
      groupName: "Nombre del Grupo",
      groupNamePlaceholder: "Ej: Mi Familia, 5to Grado A, etc.",
      yourRole: "Tu Rol en este Grupo",
      selectRole: "Selecciona tu rol...",
      institution: "Institución (opcional)",
      noInstitution: "Sin institución",
      newInstitutionBtn: "+ Nueva",
      cancel: "Cancelar",
      saveChanges: "Guardar Cambios",
      createGroup: "Crear Grupo",
      deleteGroupTitle: "¿Estás seguro que deseas eliminar el grupo?",
      deleteGroupDesc: "Esta acción no se puede deshacer. El grupo",
      deleteGroupDesc2: "será eliminado permanentemente.",
      deleteChildTitle: "¿Estás seguro que deseas eliminar este niño?",
      deleteChildDesc: "Esta acción no se puede deshacer. El niño",
      deleteChildDesc2: "será eliminado permanentemente del grupo.",
      deleteMultipleTitle1: "¿Estás seguro que deseas eliminar",
      deleteMultipleTitle2: "niño",
      deleteMultipleTitle3: "s",
      deleteMultipleDesc: "Esta acción no se puede deshacer. Los siguientes niños serán eliminados permanentemente del grupo:",
      accept: "Aceptar",
      newInstitutionTitle: "Nueva Institución",
      institutionName: "Nombre de la Institución",
      institutionNamePlaceholder: "Ej: Escuela Primaria N°25",
      institutionType: "Tipo de Institución",
      institutionTypeSelect: "Selecciona un tipo...",
      institutionTypeEducativa: "Institución Educativa",
      institutionTypeHogar: "Hogar de Tránsito",
      institutionTypeEspecial: "Institución de Educación Especial",
      institutionCountry: "País",
      institutionState: "Estado/Provincia/Ciudad",
      institutionAddress: "Dirección (opcional)",
      institutionAddressPlaceholder: "Ej: Calle Falsa 123",
      selectCountry: "Selecciona tu país...",
      selectState: "Selecciona un estado...",
      selectCountryFirst: "Primero selecciona un país...",
      noStates: "No hay estados disponibles para este país",
      createInstitution: "Crear Institución",
      addChild: "Agregar Niño",
      editChild: "Editar Niño",
      childNamePlaceholder: "Nombre del Niño",
      childLastNamePlaceholder: "Apellido del Niño",
      childGenderSelect: "Selecciona el género...",
      childBoy: "Niño",
      childGirl: "Niña",
      childNoGender: "No especifica",
      childIdPlaceholder: "ID del Niño (Opcional - Alfanumérico)",
      childEmailPlaceholder: "Email (Opcional)",
      save: "Guardar",
    },
    toast: {
      profileLoadError: "Error al cargar los datos del perfil",
      profileSaved: "✓ Perfil actualizado correctamente",
      profileSaveError: "❌ Error al actualizar el perfil",
      groupCreated: "✓ Grupo creado correctamente",
      groupCreateError: "❌ Error al crear el grupo",
      institutionCreated: "✓ Institución creada correctamente",
      institutionCreateError: "❌ Error al crear la institución",
      groupUpdated: "✓ Grupo actualizado correctamente",
      groupUpdateError: "❌ Error al actualizar el grupo",
      groupHasChildren: "❌ No se puede eliminar el grupo porque tiene niños asociados",
      groupDeleted: "✓ Grupo eliminado correctamente",
      groupDeleteError: "❌ Error al eliminar el grupo",
      childUpdated: "✓ Niño actualizado correctamente",
      childAdded: "✓ Niño agregado correctamente",
      childSaveError: "❌ Error al guardar el niño",
      childDeleted: "✓ Niño eliminado correctamente",
      childDeleteError: "❌ Error al eliminar el niño",
      childrenDeleteError: "❌ Error al eliminar los niños",
      childAlreadyLinked: "⚠️ Este niño ya está vinculado a un usuario",
      userIdError: "❌ Error: No se encontró el ID del usuario",
      childrenLoadError: "❌ Error al cargar los niños del grupo",
      statsLoadError: "Error al cargar las estadísticas del grupo",
      linkCopied: "✓ Link de invitación copiado para",
      childrenDeleted: "niño(s) eliminado(s) correctamente",
      identifyGroupError: "❌ Error: No se pudo identificar el grupo a actualizar",
    },
    roles: {
      grandparent: "Abuelo/a",
      sibling: "Hermano/a",
      teacher: "Maestro/a",
      parent: "Madre/Padre",
      other: "Otro",
      professor: "Profesor/a",
      psychologist: "Psicólogo/a",
      uncle: "Tío/a",
      tutor: "Tutor",
    },
  },
  admin: {
    dashboard: {
      title: "Panel de Administración",
      users: "Usuarios",
      approve: "Aprobar",
      reject: "Rechazar",
      approved: "Aprobado",
      pending: "Pendiente",
      all: "Todos",
      search: "Buscar",
      noUsers: "No hay usuarios",
    },
    usuarios: {
      colRecibeAlertas: "Recibe Alertas de Howe",
      recibeAlertasSi: "Sí",
      recibeAlertasNo: "No",
      toastAlertaOn: "Alertas activadas correctamente",
      toastAlertaOff: "Alertas desactivadas correctamente",
      toastAlertaError: "Error al actualizar recibe alertas",
      toastHowemakerOn: "Howemaker activado correctamente",
      toastHowemakerOff: "Howemaker desactivado correctamente",
      toastHowemakerError: "Error al actualizar Howemaker",
    },
    howemakers: {
      navLabel: "⭐ Howemakers",
      title: "Howemakers",
      subtitle: "Gestioná qué usuarios tienen acceso a las funciones Howemaker, como el cuarto del Árbol Familiar.",
      refresh: "Actualizar",
      searchPlaceholder: "Buscar por nombre, apellido o usuario...",
      childrenTitle: "Niños",
      adultsTitle: "Adultos",
      colUsuario: "Usuario",
      colApellido: "Apellido",
      colEdad: "Edad",
      colInstitucion: "Institución",
      colHowemaker: "Howemaker",
      si: "Sí",
      no: "No",
      noChildren: "No hay niños para mostrar",
      toastLoadError: "Error al cargar los niños",
      toastBulkPartial: "{ok} actualizados, {failed} no se pudieron actualizar",
      instFilterAll: "Todas las instituciones",
      instFilterNone: "Sin institución",
      bulkSetSi: "Marcar Howemaker: Sí",
      bulkSetNo: "Marcar Howemaker: No",
    },
    cuartos: {
      navLabel: "🏠 Cuartos",
      title: "Cuartos de la casa",
      subtitle: "Configurá qué cuartos están disponibles para todos los niños o solo para Howemakers.",
      roomEmotions: "Cuarto de las Emociones",
      roomHowe: "Mi Cuarto Howe",
      roomDiary: "Diario",
      roomFamilyTree: "Árbol Familiar",
      visibilityAll: "Todos",
      visibilityHowemakers: "Solo Howemakers",
      toastSaved: "Configuración actualizada correctamente",
      toastError: "Error al actualizar la configuración",
    },
    instituciones: {
      navLabel: "🏛️ Instituciones",
      title: "Instituciones",
      subtitle: "Listado de instituciones registradas en la plataforma. Cambiá el estado para activar o desactivar.",
      noData: "No hay instituciones registradas",
      colInstitucion: "Institución",
      colTipo: "Tipo",
      colUbicacion: "Ubicación",
      colEstado: "Estado",
      colAccion: "Acción",
      statusActiva: "Activa",
      statusInactiva: "Inactiva",
      statusCreada: "Creada",
      tipoEducativa: "Educativa",
      tipoHogar: "Hogar de Tránsito",
      tipoEspecial: "Ed. Especial",
      btnActivar: "Activar",
      btnInactivar: "Inactivar",
      btnReactivar: "Reactivar",
      confirmInactivar: "¿Inactivar la institución \"{nombre}\"? Los grupos asociados no podrán generar links de invitación.",
      toastUpdated: "Estado actualizado correctamente",
      toastError: "Error al actualizar el estado de la institución",
      grupoConfianzaTitle: "Grupo que recibe alertas de parte de Howe (Grupo de Confianza)",
      grupoConfianzaDesc: "Estos mails recibirán notificaciones cuando Howe detecte una situación de riesgo en el chat de un niño vinculado a esta institución.",
      grupoConfianzaUsuarios: "Usuarios con alertas activas",
      grupoConfianzaExtra: "Mails adicionales",
      grupoConfianzaNoUsuarios: "Ningún usuario tiene alertas activadas para esta institución.",
      grupoConfianzaNoExtra: "Sin mails adicionales configurados.",
      grupoConfianzaAddPlaceholder: "Ingresá un email",
      grupoConfianzaBtnAdd: "Agregar",
      grupoConfianzaBtnSave: "Guardar cambios",
      grupoConfianzaSaved: "Grupo de confianza actualizado correctamente",
      grupoConfianzaError: "Error al actualizar el grupo de confianza",
      grupoConfianzaInvalidEmail: "Ingresá un email válido",
      grupoConfianzaVerGrupo: "Ver Grupo de Confianza",
      grupoConfianzaOcultar: "Ocultar",
    },
  },
  register: {
    options: {
      child: "Niño",
      adult: "Adulto/Profesional",
      alreadyHaveAccount: "¿Ya tienes cuenta?",
      signIn: "Inicia sesión",
    },
    child: {
      step1: {
        welcome: "¡Bienvenidos a Howe!",
        ageQuestion: "¿Cuántos años tienes?",
        chooseAvatar: "Elige tu avatar:",
        boy: "Niño",
        girl: "Niña",
      },
      step2: {
        nameQuestion: "¿Cuál es tu nombre?",
        nameSubtitle: "Escribe el nombre que usarás para jugar y explorar en Howe.",
        namePlaceholder: "Tu nombre",
        acceptTerms: "Acepto los",
        termsLink: "términos y condiciones",
        acceptPrivacy: "Acepto la",
        privacyLink: "política de privacidad",
      },
      errors: {
        nameRequired: "Por favor, ingresa tu nombre",
        ageRequired: "Por favor, ingresa tu edad",
        termsRequired: "Debes aceptar los términos y condiciones",
        privacyRequired: "Debes aceptar la política de privacidad",
        general: "Error al registrar el niño. Por favor, intenta nuevamente.",
      },
    },
    adult: {
      title: "Registro",
      subtitle: "Adulto/Profesional",
      welcome: "Bienvenido a HOWE, la tierra infancia de todos los niños.",
      emailPlaceholder: "Ingrese su correo",
      passwordPlaceholder: "Ingrese su contraseña",
      acceptTermsAndPrivacy: "Acepto los",
      termsLink: "Términos y Condiciones",
      andThe: "y la",
      privacyLink: "Política de Privacidad",
      register: "Registrarse",
      alreadyHaveAccount: "¿Ya tienes cuenta?",
      signInHere: "Inicia sesión aquí",
      errors: {
        invalidEmail: "Por favor, ingresa un email válido.",
        passwordTooShort: "La contraseña debe tener al menos 6 caracteres.",
        termsRequired: "Debes aceptar los términos y condiciones para continuar.",
        emailAlreadyExists: "Te estás intentando registrar con un usuario existente",
        allFieldsRequired: "Por favor, completa todos los campos requeridos.",
        general: "Error al completar el registro. Por favor, intenta nuevamente.",
      },
      step2: {
        codeInfo: "Te enviamos un código de 4 dígitos a",
        codePlaceholder: "Ingrese el código",
        validate: "Validar",
        resendCode: "Reenviar código",
        codeResent: "✓ Código reenviado correctamente",
      },
      step3: {
        personalData: "Datos Personales",
        firstNamePlaceholder: "Nombre",
        lastNamePlaceholder: "Apellido",
        selectCountry: "Selecciona tu país...",
        selectProvince: "Selecciona tu provincia/estado...",
        selectCountryFirst: "Primero selecciona un país...",
        noStates: "No hay estados disponibles para este país",
        next: "Siguiente",
      },
    },
  },
  piggyBank: {
    title: "Mis HoweCoins",
    currentBalance: "Saldo actual",
    howToEarn: "¿Cómo ganás coins?",
    spend: "Gastar",
    trustedAdult: {
      menuItem: "Adultos vinculados",
      title: "Mi adulto de confianza",
      linkedTitle: "Adultos vinculados a mis grupos",
      wobiMessage: "Es muy importante que Wobi conozca tu adulto de confianza, esa persona con la que vos te sentís seguro y podés contarle lo que te pasa. Puede ser un familiar, un maestro, o un profesional en quien confíes.",
      noTrustedAdult: "Sin definir",
      namePlaceholder: "Nombre del adulto de confianza",
      emailPlaceholder: "Email del adulto de confianza",
      emailInvalid: "Ingresá un correo electrónico válido (ej: nombre@ejemplo.com)",
      saveButton: "Guardar",
      saveSuccess: "¡Adulto de confianza guardado correctamente!",
      emotionValidation: "Para utilizar el chat de las emociones primero debes tener un adulto de confianza mencionado.",
      noLinkedAdults: "No hay adultos vinculados a tus grupos todavía.",
      back: "Volver",
      loading: "Cargando...",
    },
    activities: {
      emotions: {
        name: "Hablar sobre mis emociones",
        desc: "Contarle a Wowi cómo te sentís",
      },
      body: {
        name: "Registrar lo que siento en el cuerpo",
        desc: "Marcá en el cuerpo dónde sentís tu emoción",
      },
      decorate: {
        name: "Decorar mi cuarto Howe",
        desc: "Comprá decoraciones con tus HoweCoins",
      },
      story: {
        name: "Escuchar un cuento",
        desc: "Escuchá un cuento sobre emociones",
      },
      agenda: {
        name: "Realizar una actividad de la agenda",
        desc: "Completá una actividad propuesta",
      },
      diary: {
        name: "Escribir en mi diario",
        desc: "Anotá tus pensamientos del día en el diario",
      },
      diaryPhoto: {
        name: "Subir foto al diario",
        desc: "Decorá con una foto los cuadros del cuarto Mi Diario",
      },
    },
  },
  familyTree: {
    intro: {
      greeting: "¡Hola! 🌱",
      message: "Tu historia empezó mucho antes de que nacieras. Cada persona de tu familia trajo algo único que te ayudó a ser quien sos hoy. ¿Querés descubrirlo conmigo?",
      inputPlaceholder: "Escribime algo...",
      start: "¡Empecemos!",
    },
    seed: {
      title: "Primero te agrego a VOS, que sos la semilla de este árbol 🌱",
      nameLabel: "¿Cómo te llamás?",
      namePlaceholder: "Tu nombre",
      dobLabel: "¿Cuándo naciste?",
      funLabel: "Contame algo curioso de vos",
      funPlaceholder: "Mi comida favorita, mi juguete preferido...",
      button: "Plantar mi semilla 🌱",
    },
    tree: {
      myEnvironment: "Sobre mí",
      zoomLabel: "Zoom",
      unlockGrandparents: "Desbloquear abuelos",
    },
    node: {
      tabDesc: "Sobre él/ella",
      tabGift: "Regalo del alma",
      tabMsg: "Mensajes",
      deceasedLabel: "Este familiar ya no está con nosotros ☁️",
      toggleDeceasedTitle: "Tocá la nube si este familiar ya no está con nosotros",
      photoAvatarLabel: "Foto / Avatar",
      countryLabel: "País",
      descPlaceholder: "Le gusta cocinar y siempre me hace reír...",
      giftSectionLabel: "Un talento o valor que te regaló",
      msgPlaceholder: "Escribile un mensaje...",
      msgHelper: "Dejale guardado un mensaje especial",
      saveButton: "Guardar",
    },
    addModal: {
      namePlaceholder: "NOMBRE",
      addPhoto: "Agregar foto",
      addButton: "Agregar",
    },
    countryNames: {
      AR: "Argentina", BR: "Brasil", UY: "Uruguay", CL: "Chile", PY: "Paraguay",
      BO: "Bolivia", MX: "México", ES: "España", US: "Estados Unidos", IT: "Italia",
      FR: "Francia", DE: "Alemania", PE: "Perú", CO: "Colombia", VE: "Venezuela", CU: "Cuba",
    },
    entorno: {
      title: "Sobre mí",
      subtitle: "Contame un poco más sobre vos ✨",
      actividad: "¿Qué te gusta hacer?",
      amigo: "Nombre de mis amigos",
      comida: "Comida favorita",
      color: "Color favorito",
    },
    chat: {
      title: "Wobi",
      inputPlaceholder: "Escribir...",
      opening: "¡Hola! Contame sobre tu familia — con quién vivís, quiénes son importantes para vos. 💛",
      thinking: "Wobi está pensando...",
      error: "Uy, no te escuché bien. ¿Podés contarme de nuevo? 💛",
      thanks: "¡Qué lindo, gracias por contarme! 💛",
      confirmAdd: "¿Agrego a {name} como tu {rel}? 💛",
      confirmYes: "Sí",
      confirmNo: "No, es otro nombre",
      confirmRetry: "Ah, ¡decime el nombre de nuevo! ✏️",
      resizeHandle: "Arrastrá para agrandar o achicar el chat",
    },
    bg: {
      title: "Elegí el clima 🌤️",
    },
    decorate: {
      title: "Decorar el árbol 🌸",
      colorLabel: "Color de las copas",
      flowers: "Florcitas",
      bugs: "Bichitos voladores",
    },
    extras: {
      title: "Agregar vínculo",
    },
    link: {
      buttonTitle: "Unir dos familiares",
      pickFirst: "🔗 Tocá un familiar para empezar a unirlo",
      pickSecond: "🔗 Ahora tocá con quién se une",
      question: "¿Cómo están unidos {a} y {b}?",
      pareja: "Son pareja 💑",
      hermano: "Son hermanos/as",
      esHijoDe: "es hijo/a de",
      especial: "Vínculo especial 💜",
      removeLine: "Borrar esta unión (sin borrar a nadie)",
    },
    typeGroups: {
      fixed: "Familia (posición fija)",
      free: "Otros vínculos",
    },
    reset: {
      buttonTitle: "Empezar de nuevo",
      title: "¿Borrar todo el árbol?",
      warning: "Se van a borrar todos los familiares, vínculos y decoraciones. Esto no se puede deshacer.",
      cancel: "Cancelar",
      confirm: "Sí, borrar todo",
    },
    detail: {
      photoError: "No se pudo cargar esa foto. Probá con otra imagen.",
    },
    nodeLabels: {
      bisAbueloPaterno: "Bisabuelo paterno",
      bisAbuelaPaterna: "Bisabuela paterna",
      bisAbueloMaterno: "Bisabuelo materno",
      bisAbuelaMaterna: "Bisabuela materna",
      abueloPaterno: "Abuelo paterno",
      abuelaPaterna: "Abuela paterna",
      abueloMaterno: "Abuelo materno",
      abuelaMaterna: "Abuela materna",
      papa: "Papá",
      mama: "Mamá",
      tioPapa: "Tío / Padrino",
      tioMama: "Tía / Madrina",
      hermano: "Hermano/a",
      primo: "Primo/a",
      mascota: "Mascota",
      especial: "Persona especial",
      padreAdoptivo: "Padre adoptivo",
      madreAdoptiva: "Madre adoptiva",
      tio: "Tío/Tía",
      padrino: "Padrino",
      madrina: "Madrina",
      parejaPapa: "Pareja de papá",
      parejaMama: "Pareja de mamá",
      amigo: "Amigo/a",
      self: "Vos",
    },
    nodeQuestions: {
      bisAbueloPaterno: "Aunque no lo conozcas, ¿querés incluirlo en tu árbol?",
      bisAbuelaPaterna: "Aunque no la conozcas, ella forma parte de vos. ¿La incluimos?",
      bisAbueloMaterno: "Aunque no lo conozcas, ¿querés incluirlo en tu árbol?",
      bisAbuelaMaterna: "Aunque no la conozcas, ella forma parte de vos. ¿La incluimos?",
      abueloPaterno: "¿Cómo se llama el papá de tu papá?",
      abuelaPaterna: "¿Cómo se llama la mamá de tu papá?",
      abueloMaterno: "¿Cómo se llama el papá de tu mamá?",
      abuelaMaterna: "¿Cómo se llama la mamá de tu mamá?",
      papa: "¿A quién llamás papá? ¿Cuál es su nombre completo?",
      mama: "¿A quién llamás mamá? ¿Cuál es su nombre completo?",
      tioPapa: "¿Hay alguien más al lado de papá? Un tío, padrino o persona especial.",
      tioMama: "¿Y al lado de mamá? Tía, madrina o persona especial.",
      hermano: "¿Tenés hermanos? ¿Cómo se llama?",
      primo: "¿Tiene hijos? Agreguemos a tu primo/a.",
      mascota: "¿Tenés una mascota? ¿Cómo se llama?",
      especial: "¿Hay alguien especial, como una madrina o mentor?",
    },
    gifts: ["Valentía", "Creatividad", "Humor", "Amor por la música", "Ternura", "Fortaleza", "Sabiduría", "Alegría"],
    questions: {
      1: [
        "¿Cuándo naciste? ¿Qué día y en qué ciudad? 🌍",
        "¿Cómo eras de bebé? ¿Te contaron algo curioso? 👶",
        "¿Cuándo se te cayó el primer diente? 🦷",
        "¿Sos el mayor, el del medio o el más chico? 👨‍👩‍👧",
        "¿Cuál es tu comida favorita? 🍕",
      ],
      2: [
        "¿A quién llamás mamá? ¿Cuál es su nombre completo? 💛",
        "¿A quién llamás papá? ¿Cuál es su nombre? 💙",
        "¿Quién te cuida todos los días? ¿Quién te canta canciones? 🎶",
        "¿Hay alguien que se fue pero sigue siendo importante para vos? 🌟",
        "¿Qué le regalarías a quien te cuida? 🎁",
      ],
      3: [
        "¿Cómo se llama tu colegio? ¿Qué grado cursás? 🏫",
        "¿Quién es tu mejor amigo/a? ¿Qué les gusta hacer juntos? 👫",
        "¿Hacés alguna actividad extraescolar? (deporte, arte, música...) 🎨",
        "¿Cuál es tu estación del año favorita y por qué? 🌸",
        "¿Celebran alguna fecha especial en familia? 🎄",
      ],
      4: [
        "¿Quiénes son tus abuelos? ¿Los conocés? 👴👵",
        "¿De dónde vienen tus abuelos? ¿En qué ciudad o país nacieron? 🌍",
        "¿A qué jugaban tus abuelos cuando eran chicos? 🎮",
        "¿Hay alguien en tu familia que ya no está? ¿Querés incluirlo? 🌙",
        "¿Qué creés que heredaste de cada abuelo? 💫",
      ],
    },
  },
};
